import request from './request';
/**
 * 电子签章相关接口
 * @author 小圣贤君
 * @time 2020/2/21
 */
export default {
  /**
   * 获取签署合同url
   * @param merchantCode 商户code
   * @param returnUrl 页面跳转Url
   * @param type 类型 1：购买 2：物流 
   * @param userId 下单系统用户id
   */
  getSignAgreementUrl(data) {
    return request.post('/fadada/esignature/getSignAgreementUrl', data);
  },
  /**
   * 查看协议
   * @param contractid
   */
  viewAgreement(contractid) {
    return request.get('/fadada/esignature/viewAgreement/' + contractid);
  }
}



// WEBPACK FOOTER //
// ./src/api/signContractService.js